// Per-output input, the mapped preview switch, mapping mode's open state and the stage's fit-editing aids. The mapping itself is the active map (`~/store/maps`).
import { createSlice } from '@reduxjs/toolkit'

// `editor` is the map editor's own view; it never changes what an output shows.
export const OUTPUT_PATHS = ['mirror', 'output', 'main', 'editor']

const initialState = {
	// path → { input: 'output' | 'source', black }. `black` wins over picture and test card.
	outputs: {},
	// Mapping mode is up. Not persisted.
	active: false,
	// The map editor's overlays: `grid` the test card (through the surfaces; whole under the corner-pin tool) and `slices_grid` every slice outlined, the selected one gridded, both not persisted; `on_output` sends them and the selection to every output.
	grid: false,
	slices_grid: false,
	on_output: true,
	// The shape whose fit is hovered in Properties: the stage outlines it. Not persisted.
	hover: null,
	// The main window's Output panel shows the mapped picture outside performance mode too.
	preview: false,
	// `{ node, end? }` while the stage waits for a click on the segment that shape's fit runs along. Not persisted.
	edge_pick: null,
	// `/output`: the runner's output is black (`setRemoteMap`'s `black`). Not persisted.
	remote_black: false,
}

const outputMappingSlice = createSlice({
	name: 'outputMapping',
	initialState,
	reducers: {
		setProjectionMap: (state, { payload }) => {
			state.active = payload
			state.edge_pick = null
			if (!payload) {
				state.hover = null
				state.grid = false
				state.slices_grid = false
			}
		},
		/** `payload`: some of `grid`, `slices_grid`, `on_output`. */
		setOverlay: (state, { payload }) => {
			Object.assign(state, payload)
		},
		setOutputInput: (state, { payload: { path, input } }) => {
			state.outputs[path] = { ...state.outputs[path], input }
		},
		setOutputBlack: (state, { payload: { path, black } }) => {
			state.outputs[path] = { ...state.outputs[path], black }
		},
		setMappingHover: (state, { payload }) => {
			state.hover = payload
		},
		setMappingPreview: (state, { payload }) => {
			state.preview = payload
		},
		setEdgePick: (state, { payload }) => {
			state.edge_pick = payload
		},
	},
	extraReducers: builder => {
		builder.addCase('maps/setRemoteMap', (state, { payload }) => {
			state.remote_black = !!payload.black
		})
	},
})

export const {
	setOutputInput,
	setOutputBlack,
	setProjectionMap,
	setMappingHover,
	setMappingPreview,
	setEdgePick,
	setOverlay,
} = outputMappingSlice.actions

export * from './selectors'

export default outputMappingSlice.reducer
